/* jslint browser: true */
import React, { Component } from 'react';

class PaymentMethod extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className="lra-box">
            <div className="lra-box-header">
                    Mode de paiement
            </div>
            <div className="lra-box-body">
                <div className="payment-methods">

                      <img src="/pictures/CB.jpg" alt="CB" />
                      <img src="/pictures/Visa.jpg" alt="Visa" style={{margin:"auto 15px"}}/>
                      <img src="/pictures/mastercard.jpg" alt="MasterCard" />

                  </div>
                  <div style={{textAlign: 'center'}}>
                      <button type="button" className="btn myBtn" onClick={this.props.pay}>Payer</button>
                  </div>

                </div>

        </div>);
    }
}

export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/components/commande/PaymentMethod.js